import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Globe, Lock, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, packageBonuses, packageExtras, packageVolumes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-zinc-950 relative" data-id="element-174" data-mp="1jai9cuzlw1rm">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-175" data-mp="1nbbw3l1bbaix">
        <div className="text-center mb-10" data-id="element-176" data-mp="1ncwq99jpsrg9">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-3 text-white" data-id="element-177" data-mp="1s8luvralcyjf">
            Your complete <span className="text-amber-400" data-id="element-178" data-mp="1x9rpjuntavvl">MMA Coach Ready</span> package
          </h2>
          <p className="font-display font-bold uppercase tracking-wide text-zinc-300 text-sm md:text-base" data-id="element-179" data-mp="2282ze5e3x6dt">
            The complete 6-in-1 coaching system — ready for your next session.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-zinc-800 border-2 border-amber-400/80 rounded-3xl p-1 relative shadow-2xl shadow-black/60" data-id="element-180" data-mp="7utkfy2skso6">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-400 text-zinc-950 font-display font-extrabold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-181" data-mp="1cosgw0zlflgn">
            <Sparkles size={14} aria-hidden="true" data-id="element-182" data-mp="20fxue9i2a1ns" /> Complete Package
          </div>
          <div className="bg-zinc-900 rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-183" data-mp="1vhcs84j917wp">
            <div className="text-left max-w-md mx-auto space-y-5 mb-8" data-id="element-184" data-mp="1vjfpn9mqe3bg">
              <ul className="space-y-2" data-id="element-185" data-mp="1rf81bdk6qpdr">
                {packageVolumes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-zinc-200" data-id="element-186" data-mp="k2z89arm9cly">
                    <Check size={16} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-187" data-mp="fzjhuw6548hp" />
                    <span data-id="element-188" data-mp="hj2x0yffm7es">{item}</span>
                  </li>)}
              </ul>
              <ul className="space-y-2 bg-zinc-950 border border-zinc-800 rounded-xl p-4" data-id="element-189" data-mp="mft8t9k7egue">
                {packageBonuses.map(item => <li key={item} className="flex items-start gap-2 text-sm text-zinc-200" data-id="element-190" data-mp="7ly7qpqahvtr">
                    <Gift size={16} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-191" data-mp="ckrlmj9hnoug" />
                    <span data-id="element-192" data-mp="3uul5ovjgdxi4">{item}</span>
                  </li>)}
              </ul>
              <ul className="grid grid-cols-2 gap-2" data-id="element-193" data-mp="3k3abwbhc2l9">
                {packageExtras.map(item => <li key={item} className="flex items-start gap-2 text-sm text-zinc-200" data-id="element-194" data-mp="3kwdtsr40u5mz">
                    <Check size={16} className="text-red-500 shrink-0 mt-0.5" aria-hidden="true" data-id="element-195" data-mp="3pvgxo889m5td" />
                    <span data-id="element-196" data-mp="3bzwow5m933zo">{item}</span>
                  </li>)}
              </ul>
            </div>

            <h3 className="text-2xl md:text-3xl font-black uppercase text-white mb-3" data-id="element-197" data-mp="3g189fwq9oz10">
              Get the complete system today
            </h3>
            <div className="mb-6" data-id="element-198" data-mp="2sd1vegy9as81">
              <span className="text-4xl md:text-5xl font-display font-black text-amber-400" data-id="element-199" data-mp="2se396t6npstg">$27 USD</span>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-200" data-mp="31copsiskixrl">
              Get MMA Coach Ready Now
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-zinc-400 mb-4" data-id="element-201" data-mp="3ba2z7yg2qmae">
              <span className="flex items-center gap-1.5" data-id="element-202" data-mp="3p1rf8ctg1uwn">
                <Lock size={12} className="text-amber-400" aria-hidden="true" data-id="element-203" data-mp="3l05uy6ekyecf" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-204" data-mp="2w47xa41rp38">
                <Zap size={12} className="text-amber-400" aria-hidden="true" data-id="element-205" data-mp="3u1drok1g774e" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-206" data-mp="hycggzpzwwca">
                <Check size={12} className="text-amber-400" aria-hidden="true" data-id="element-207" data-mp="hvzyimk8mlz8" /> Complete Digital
                Bundle
              </span>
            </div>

            <div className="bg-zinc-950 border border-zinc-800 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-208" data-mp="qrfnap64yaxy">
              <Globe className="text-zinc-300 shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-209" data-mp="vopjqorxzmva" />
              <p className="text-[11px] text-zinc-500 leading-snug" data-id="element-210" data-mp="3v6764rm77if5">
                Payment availability and currency conversion may vary according to your checkout
                provider and country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}